module.exports = __webpack_public_path__ + "static/media/capital-billboard.c381d0b7.svg";